module.exports = __webpack_public_path__ + "assets/img/00061.79532fb9.png";